import React, { type MouseEventHandler } from 'react';

import { Link } from '@reach/router';

import { useTab } from '@atlaskit/tabs';
import { token } from '@atlaskit/tokens';

import titleify from '../../utils/titleify';

interface TabProps {
	name: string;
	to: string;
	onClick?: VoidFunction;
}

const tabStyles = {
	textDecoration: 'none',
	padding: `${token('space.050', '4px')} ${token('space.150', '14px')}`,
	height: '2rem',
};

/**
 * minimal
 */
const Tab = ({ name, to, onClick }: TabProps) => {
	const tabAttrs = useTab();

	const handleClick: MouseEventHandler<HTMLAnchorElement> = (_) => {
		tabAttrs.onClick();
		onClick && onClick();
	};

	return (
		<Link
			{...tabAttrs}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			style={tabStyles}
			key={name}
			to={to}
			onClick={handleClick}
		>
			{titleify(name)}
		</Link>
	);
};

export default Tab;
